import { ExternalLink } from "lucide-react";

import type { ProteinInfo } from "@shared/schema";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";

export function ProteinInfoCard({ info }: { info: ProteinInfo }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-mono">{info.geneName}</CardTitle>
        <CardDescription>
          {info.proteinName ?? "(protein name unavailable)"}
          {info.organism ? <> &middot; <em>{info.organism}</em></> : null}
          {info.reviewed ? (
            <span className="ml-2 rounded border border-border px-1 py-0 text-[10px] font-semibold uppercase">
              Swiss-Prot
            </span>
          ) : null}
        </CardDescription>
      </CardHeader>
      {(info.function || info.uniprotId) && (
        <CardContent className="space-y-2 text-sm">
          {info.function && (
            <p className="text-muted-foreground line-clamp-3">{info.function}</p>
          )}
          {info.uniprotId && (
            <a
              href={`https://www.uniprot.org/uniprotkb/${info.uniprotId}`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 text-xs text-foreground hover:underline"
            >
              UniProt: <span className="font-mono">{info.uniprotId}</span>
              <ExternalLink className="h-3 w-3" />
            </a>
          )}
        </CardContent>
      )}
    </Card>
  );
}
